<template>
    <div class="about-container text-center bg-light overflow-hidden overflow-y-scroll py-5">
        <img :src="G.projectLogo" alt="" />
        <div class="mt-4 container p-3 text-center fs-5" v-html="G.projectAbout"></div>
    </div>
</template>


<script>
// import { ref, watchEffect } from 'vue';
// import { useStore } from "@/store";

import {G} from '@/_common';

export default {
    name: 'AboutP',
    title: 'about',
    setup() {
        // const store = useStore();
        // const TR = ref({});

        // watchEffect(() => {
        //     TR.value = store.getTranslation();
        // });

        return {
            G,
        };
    },
}
</script>


<style lang="scss">
.about-container {
    height: calc(100vh - 95px);
    //height: 100%;
}
@media (max-width: 576px) {
    .about-container {
        height: calc(100vh - 112px);
    }
}
</style>
